import React, { useEffect, useState } from 'react';
import '../css/Notification.css';
import { Link, useNavigate } from 'react-router-dom';
import  { db, ANO, database, lerNotificacaoComoResponsavel, lerNotificacaoComoServidor } from '../firebase/notificacao';

// ICONES
import { IonIcon } from '@ionic/react';
import { wifiOutline, batteryFullOutline, cellularOutline, settings, notificationsOutline, personCircle, person} from 'ionicons/icons';



const Notification = () => {
  
  const navigate = useNavigate();

  // DADOS
  const storedResponsavel = localStorage.getItem('responsavel');
  const storedSerie = localStorage.getItem('serie');
  const storedLogado = localStorage.getItem('logado');
  const storedUsuario = localStorage.getItem('usuario');  
  const [responsavel, setResponsavel] = useState(storedResponsavel ? storedResponsavel : null);
  const [serie, setSerie] = useState(storedSerie ? storedSerie : null);
  const [logado, setLogado] = useState(storedLogado ? storedLogado.toLowerCase() : null);
  const [usuario, setUsuario] = useState(storedUsuario ? storedUsuario : null);

  if (!logado) {
    localStorage.clear();
    window.location.href = "../logar";
  }

  // EVENTOS
  const [eventos, setEventos] = useState([]);

  // RELOGIO
  const [horaAtual, setHoraAtual] = useState(new Date());
  useEffect(() => {
    const intervalId = setInterval(() => {
      setHoraAtual(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);
  const formatDigit = (digit) => (digit < 10 ? '0' + digit : digit);
  const horas = formatDigit(horaAtual.getHours());
  const minutos = formatDigit(horaAtual.getMinutes());
  const segundos = formatDigit(horaAtual.getSeconds());

  const [notificacoes, setNotificacoes] = useState([]);


  const notificacoesComoResponsavel = async () => {
    try {
      const notificacoesList = await lerNotificacaoComoResponsavel(responsavel, serie);
  
      if (notificacoesList && notificacoesList.length > 0) {
        // Ordena as notificações
        const notificacoesOrdenadas = notificacoesList.sort((a, b) => (a.hora || 0) - (b.hora || 0));
  
        // Atualiza o estado das notificações
        const novaNotificacao = [...notificacoesOrdenadas, ...notificacoes];
        setNotificacoes(novaNotificacao);
      } else {
        // Se não houver notificações, apenas sinalize que o carregamento terminou
        setCarregamento(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  const notificacoesComoServidor = async () => {
    try {
      const notificacoesList = await lerNotificacaoComoServidor(logado);
      
      if (notificacoesList && notificacoesList.length > 0) {
        // Ordena as notificações
        const notificacoesOrdenadas = notificacoesList.sort((a, b) => (a.hora || 0) - (b.hora || 0));
  
        // Atualiza o estado das notificações
        const novaNotificacao = [...notificacoesOrdenadas, ...notificacoes];
        setNotificacoes(novaNotificacao);
      } else {
        setCarregamento(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  useEffect(() => {

      try {
        setCarregamento(true);
        if (logado === 'responsavel') {
          notificacoesComoResponsavel();
        } else {
          notificacoesComoServidor();
        } 
      } catch (error) {
        console.log(error);
      }
    
  }, []);

  const verChat = async (usuario, id, serie) => {
    try {
        await verNotification(id);
        if (logado === 'responsavel') {
          if (usuario !== 'direcao' && usuario !== 'coordenacao') {
            navigate(`/app/mensagens?usuario=professor`);
          } else {
            navigate(`/app/mensagens?usuario=${usuario}`);
          }
        } else {
          navigate(`/app/mensagens?usuario=${usuario}&serie=${serie}`);
        }
        
    } catch (error) {
        console.log(error);
    }
  };

  const verNotification = async (id) => {
      try {
          if (logado === 'responsavel') {
            const notificationRef = database.ref(`${ANO}/notification/${responsavel}/${id}`);
            await notificationRef.remove();
          } else {
            const notificationRef = database.ref(`${ANO}/notification/${logado}/${id}`);
            await notificationRef.remove();
          }
          return true;
      } catch (error) {
          console.log(error);
          return false;
      }
  };

  // TELA DE CARREGAMENTO
  const [carregamento, setCarregamento] = useState(false);

  return (
    
    <main className="container-notification">

      <div className="erroBanco">
          <h1>Escola fechada no momento</h1>
      </div>

      <div className="before">
        <p id="hora">
          {horas}:{minutos}:{segundos}
        </p>

        <div className="flex">
          <IonIcon icon={wifiOutline} />
          <IonIcon icon={cellularOutline} />
          <IonIcon icon={batteryFullOutline} />
        </div>
      </div>

      <header className="local">

          <h1>Notificações</h1>
          <Link to="/app/configuracoes">
            <IonIcon icon={settings} />
          </Link>

      </header>

      {notificacoes && notificacoes.length > 0 ? (

        <div className="notificacoes">
            
            {notificacoes.map((dados, index) => (
              <li onClick={() => verChat(dados.usuario, dados.id, dados.serie)}>
                  <IonIcon icon={personCircle} />
                  <div className="column">
                      {dados.usuario === 'direcao' ? (
                        <h2><strong>Direção:</strong> {dados.mensagem}</h2>
                      ) : dados.usuario === 'coordenacao' ? (
                        <h2><strong>Coordenação:</strong> {dados.mensagem}</h2>
                      ) : dados.usuario === 'professor' ? (
                        <h2><strong>Professor:</strong> {dados.mensagem}</h2>
                      ) : (
                        <h2><strong>Responsável:</strong> {dados.usuario} 
                        <br /> <strong> Série: </strong> {dados.serie}: 
                        <br /> <strong> Mensagem: </strong> {dados.mensagem}</h2>
                      )}
                      <a>{dados.hora}</a>
                  </div>
              </li>
            ))}

        </div>
      ) : (
        <>
          {carregamento ? (
            <section className='carregamento-notificacoes'>
              <span className='bola'></span>
              <h1>Carregando..</h1>
            </section>
          ) : notificacoes.length === 0 ? (
            <section className="erro">
              <IonIcon icon={notificationsOutline} />
              <h1>Nenhuma notificação encontrada</h1>
              <p>Volte novamente mais tarde...</p>
            </section>
          ) : (
            <></>
          )}
        </>
      )}

      


    </main>

  );
};


export default Notification;